import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Navbar } from "../components/Navbar";
import { formatApiError } from "../lib/api";
import { NumberChallenge } from "../components/NumberChallenge";
import { ShieldCheck } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [human, setHuman] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!human) { setError("Please enter the confirmation number to prove you're human."); return; }
    setLoading(true);
    try {
      const user = await login(email, password);
      const dest = location.state?.from ||
        (["admin", "senior_admin"].includes(user.role) ? "/admin" : user.role === "landlord" ? "/landlord" : "/tenant");
      navigate(dest);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-20">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 bg-brand flex items-center justify-center rounded-md"><ShieldCheck className="w-5 h-5 text-white" /></div>
          <h1 className="text-2xl font-bold font-heading text-slate-900">Welcome back</h1>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="login-form">
          <div>
            <label className="text-sm font-medium text-slate-700">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full border border-slate-300 rounded-md px-4 py-3 outline-none focus:ring-2 focus:ring-brand" />
          </div>
          <div>
            <div className="flex items-center justify-between">
              <label className="text-sm font-medium text-slate-700">Password</label>
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs font-semibold text-brand hover:underline">Forgot password?</Link>
            </div>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full border border-slate-300 rounded-md px-4 py-3 outline-none focus:ring-2 focus:ring-brand" />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <NumberChallenge onValidChange={setHuman} />
          <button data-testid="login-submit" disabled={loading}
            className="bg-brand text-white font-semibold py-3 rounded-md hover:bg-brand-hover transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Log in"}
          </button>
        </form>
        <p className="mt-5 text-sm text-slate-500">No account? <Link to="/register" state={{ from: location.state?.from }} className="text-brand font-medium">Sign up</Link></p>
      </div>
    </div>
  );
}
